











































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({ default: 250 })
  delay!: number

  show = false

  mounted() {
    setTimeout(() => this.show = true, this.delay)
  }
}
